<div class="content">
    <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [selected]="selectedOption"
        [(ngModel)]="selectedOption">
        <mat-radio-button class="example-radio-button" *ngFor="let configurationName of configurationsNameTranslated"
            [value]="configurationName">
            {{ configurationName.Name }}
        </mat-radio-button>
    </mat-radio-group>
</div>

<div>
    <div class="description" *ngIf="selectedOption">
        <p>{{ "visibility.labels.description" | translate}}:</p>
        <div>{{ selectedOption.Description }}</div>
    </div>

    <div class="example-button-row">
        <button mat-raised-button (click)="onCancelClick()">{{ "element.configurationMessages.title.cancel" | translate}}</button>
        <button mat-raised-button (click)="onSaveClick()">{{ "visibility.labels.save" | translate}}</button>
    </div>
</div>